import React, { useMemo } from "react";
import { PageDialogContent } from "../../components/dialog";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useGetNurseQuery, useGetProviderQuery } from "../../services/chatService";

function ChatMembersPopup({onCancelHandler}) {
    

        
    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,

    }));
    const {data: providers } = useGetProviderQuery({location_id: selectedChat?.location?.id});
    const {data: nurses } = useGetNurseQuery({location_id: selectedChat?.location?.id});

    console.log(providers, "providers");

    return (
        <PageDialogContent>
            <div className="flex gap-4 pb-4">
                <div className="flex-1 border rounded-lg p-4 shadow-md bg-white">
                    <h2 className="text-lg font-semibold mb-2 bg-teal-500 text-white p-1 rounded-md">Practice Staff</h2>
                    <ul className="space-y-2">
                        {providers.map((provider)=>{
                            if(provider.user_name){
                                return(
                                    <li key={provider.id} className="p-2 border rounded-md">{provider.user_name}</li>
                                )
                            }
                            return null;
                        })}
                    </ul>
                </div>
                
                <div className="flex-1 border rounded-lg p-4 shadow-md bg-white">
                    <h2 className="text-lg font-semibold mb-2 bg-teal-500 text-white p-1 rounded-md">Nursing Staff</h2>
                    <ul className="space-y-2">
                        {nurses.map((nurse)=>{
                            if(nurse.name){
                                return(
                                    <li key={nurse.id} className="p-2 border rounded-md">{nurse.name}</li>
                                )
                            }
                            return null;

                        })}
                    </ul>
                </div>
            </div>
        </PageDialogContent>
    );
}

export default ChatMembersPopup;
